import { Box, Paper, Typography, type SxProps, type Theme } from '@mui/material'
import type React from 'react'

export function EmptyState (props: {
  title: string
  description?: string
  icon?: React.ReactNode
  actions?: React.ReactNode
  sx?: SxProps<Theme>
}): JSX.Element {
  return (
    <Paper
      elevation={0}
      sx={[
        {
          alignItems: 'center',
          backgroundColor: 'background.paper',
          border: theme => `1px solid ${theme.palette.divider}`,
          borderRadius: '12px',
          boxSizing: 'border-box',
          boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 154,
          px: 3,
          py: 4,
          textAlign: 'center',
          width: '100%'
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx])
      ]}
    >
      {props.icon !== undefined && (
        <Box
          aria-hidden="true"
          sx={{
            alignItems: 'center',
            backgroundColor: theme => theme.palette.action.hover,
            borderRadius: '50%',
            color: 'text.secondary',
            display: 'flex',
            height: 44,
            justifyContent: 'center',
            mb: 1.5,
            width: 44,
            '& svg': {
              fontSize: 24
            }
          }}
        >
          {props.icon}
        </Box>
      )}
      <Typography
        sx={{
          color: 'text.primary',
          fontSize: '1rem',
          fontWeight: 600,
          lineHeight: 1.35
        }}
      >
        {props.title}
      </Typography>
      {props.description !== undefined && (
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: '0.875rem',
            fontWeight: 400,
            lineHeight: 1.45,
            maxWidth: 440,
            mt: 0.75
          }}
        >
          {props.description}
        </Typography>
      )}
      {props.actions !== undefined && (
        <Box sx={{ mt: 2 }}>
          {props.actions}
        </Box>
      )}
    </Paper>
  )
}
